import React, { useEffect } from 'react';

import { ProductDetail } from 'components/product-detail';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { ProductWizardProvider } from 'state/product-wizard';
import { ProductMenuObject } from 'state/product-wizard/types';

export interface IMenuWizardProps {
  product: ProductMenuObject;
}

const feedbackWidgetScriptId = 'wizard2FeedbackWidgetScriptSrc';
const feedbackWidgetScriptSrc =
  'https://rbictg.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/-dtzt95/b/3/c95134bc67d3a521bb3f4331beb9b804/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?jsI18nTransformer=migrated&locale=en-US&collectorId=c19d12fc';

// Wizard 2.0
export const ProductWizard = React.memo<IMenuWizardProps>(({ product }) => {
  const isIssueCollectorEnabled = useFlag(LaunchDarklyFlag.ENABLE_NEW_WIZARD_ISSUE_COLLECTOR);

  useEffect(() => {
    if (isIssueCollectorEnabled) {
      const script = document.createElement('script');
      script.id = feedbackWidgetScriptId;
      script.src = feedbackWidgetScriptSrc;
      script.async = true;
      document.body.appendChild(script);
    }

    return () => {
      document.getElementById(feedbackWidgetScriptId)?.remove();
      document.getElementById('atlwdg-trigger')?.remove();
      document.getElementById('atlwdg-blanket')?.remove();
      document.getElementById('atlwdg-container')?.remove();
    };
  }, [isIssueCollectorEnabled]);

  return (
    <ProductWizardProvider product={product}>
      <ProductDetail />
    </ProductWizardProvider>
  );
});
